import { useSettings } from "@contexts/settings";
import { Loader } from "@core/components";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";

const UnsecuredLayout = () => {
  const { ThemeSwticher } = useSettings();
  return (
    <div className="min-h-screen" data-testid="unsecured-layout-wrapper">
      <Suspense
        fallback={
          <div className="flex h-full w-full flex-1 items-center justify-center">
            <Loader />
          </div>
        }
      >
        <Outlet />
      </Suspense>
      <ThemeSwticher className="absolute top-3 right-3 sm:top-6 sm:right-6" />
    </div>
  );
};

export default UnsecuredLayout;
